/**
 * @generated SignedSource<<1160a81a4945833b686762c9158cbcba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AuthProviderQuery$variables = Record<PropertyKey, never>;
export type AuthProviderQuery$data = {
  readonly activeUsers: {
    readonly nodes: ReadonlyArray<{
      readonly email: string;
      readonly firstName: string;
      readonly fullName: string;
      readonly hubId: string;
      readonly id: string;
      readonly lastName: string;
      readonly organisations: {
        readonly nodes: ReadonlyArray<{
          readonly axleId: string;
          readonly hubId: string;
          readonly id: string;
          readonly name: string;
        }>;
      };
    }>;
  };
};
export type AuthProviderQuery = {
  response: AuthProviderQuery$data;
  variables: AuthProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubId",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserConnection",
    "kind": "LinkedField",
    "name": "activeUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OrganisationConnection",
            "kind": "LinkedField",
            "name": "organisations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Organisation",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "axleId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthProviderQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthProviderQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c162687bd6ea5956ad23d9a5785f563c",
    "id": null,
    "metadata": {},
    "name": "AuthProviderQuery",
    "operationKind": "query",
    "text": "query AuthProviderQuery {\n  activeUsers {\n    nodes {\n      id\n      hubId\n      fullName\n      firstName\n      email\n      lastName\n      organisations {\n        nodes {\n          id\n          hubId\n          axleId\n          name\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3b2a859670ecb9d4be4ae52f07d4ed5";

export default node;
